import { gql, TypedDocumentNode } from '@apollo/client';
import { OrderSummary, ORDER_SUMMARY_FRAGMENT } from '../useOrderSummary';
import { UpdateOrderAction, OrderState } from '../useUpdateOrder';

export type ChargeOrderMutation = {
  chargeOrder: {
    __typename: 'UpdateOrderPayload';
    data: OrderSummary[];
  };
};

export type ChargeOrderMutationVariables = {
  orderId: string;
  input: {
    data: {
      action_type: UpdateOrderAction;
      attributes: {
        country_code: string;
        order_state: OrderState;
        payment_id?: number;
        selected_items_ids?: number[] | null;
        use_reward_points?: boolean;
        use_site_credit?: boolean;
      };
      id: string;
      type: 'orders';
    };
  };
};

export const CHARGE_ORDER_MUTATION: TypedDocumentNode<
  ChargeOrderMutation,
  ChargeOrderMutationVariables
> = gql`
  mutation ChargeOrder($orderId: String!, $input: ChargeOrderMutationVariables!) {
    chargeOrder(orderId: $orderId, input: $input)
      @rest(
        type: "UpdateOrderPayload"
        endpoint: "moda"
        path: "/v3.5/orders/{args.orderId}"
        method: "PATCH"
      ) {
      data @type(name: "RestOrderSummary") {
        ...OrderSummaryFragment
      }
    }
  }
  ${ORDER_SUMMARY_FRAGMENT}
`;
